import GC from '@grapecity/spread-sheets';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import i18nWorkbook from '@/i18ns/i18nWorkbook';
import commonFunction from '../commonFunction';
import explanationFormHelper from '@/commons/workbook/explanationFormHelper';
import explanationFormViewHelper from '@/commons/workbook/explanationFormViewHelper';
import workbookAvaHelper from '@/commons/workbook/workbookAvaHelper';
  

/**
 * Danh sách các command custom
 */
export const commandCustoms = [
    {
        nameCommand: 'addRowCustom',
        canUndo: true,
        actionCommand: function (wb, options) { commandAddRowCustom(wb) }
    },
    {
        nameCommand: 'insertColumnsCustom',
        canUndo: true,
        actionCommand: function (wb, options) { commandInsertColumnsCustom(wb) }
    },
    {
        nameCommand: 'deleteRowCustom',
        canUndo: true,
        actionCommand: function (wb, options) { commandDeleteRowCustom(wb) }
    },
    {
        nameCommand: 'insertRowsDetail',
        canUndo: true,
        actionCommand: function (wb, options) { commandInsertRowsDetail(wb) }
    },
    {
        nameCommand: 'insertCellTypeText',
        canUndo: true,
        actionCommand: function (wb, options) { explanationFormHelper.contextMenuCommandCustom(wb, 'text') }
    },
    {
        nameCommand: 'insertCellTypeCombobox',
        canUndo: true,
        actionCommand: function (wb, options) { explanationFormHelper.contextMenuCommandCustom(wb, 'combobox') }
    },
    {
        nameCommand: 'shiftCellsRight',
        canUndo: true,
        actionCommand: function (wb, options) { commandInsertShiftCellsRight(wb) }
    },
    {
        nameCommand: 'shiftCellsDown',
        canUndo: true,
        actionCommand: function (wb, options) { commandInsertShiftCellsDown(wb) }
    },
    {
        nameCommand: 'copyCustom',
        canUndo: false,
        actionCommand: function (wb, options) { explanationFormHelper.contextMenuCommandCustom(wb, 'copy') }

    },
    {
        nameCommand: 'cutCustom',
        canUndo: false,
        actionCommand: function (wb, options) { explanationFormHelper.contextMenuCommandCustom(wb, 'cut') }

    },
    {
        nameCommand: 'pasteCustom',
        canUndo: true,
        actionCommand: function (wb, options) { explanationFormHelper.contextMenuCommandCustom(wb, 'paste') }

    },
    {
        nameCommand: 'actionToolbar',
        canUndo: true,
        actionCommand: function (wb, options) { explanationFormHelper.excuteActionToolbar(wb, options) }

    },
    {
        nameCommand: 'InsertColumnDetailMission',
        canUndo: true,
        actionCommand: function (wb, options) { workbookAvaHelper.reRenderWorkbookAddColumn(wb, options) }

    },
    {
        nameCommand: 'openDialogFindAndReplace',
        canUndo: false,
        actionCommand: function (wb, options) { 
            
        }
    },
    {
        nameCommand: 'showRowsTableCondition',
        canUndo: true,
        actionCommand: function (wb, options) { explanationFormHelper.showRowsTableCondition(wb, options) }

    },
];
/**
 * Thêm dòng custom
 * @param {workbook} wb 
 * @returns 
 */
const commandAddRowCustom = (wb) => {
    var sheet = wb.getActiveSheet();
    // Get selected range
    let rangeSelects = sheet?.getSelections();
    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;

    wb.suspendPaint();
    wb.suspendEvent();
    rangeSelects.forEach(function (selection) {
        sheet.addRows(selection.row, selection.rowCount); // Thêm một dòng mới
        sheet.copyTo(
            selection.row + selection.rowCount,
            0,
            selection.row,
            0,
            selection.rowCount,
            selection.colCount,
            GC.Spread.Sheets.CopyToOptions.formula,
        );
        sheet.copyTo(
            selection.row + selection.rowCount,
            0,
            selection.row,
            0,
            selection.rowCount,
            selection.colCount,
            GC.Spread.Sheets.CopyToOptions.style,
        );
        // set màu cho dòng mới thêm mặc định là màu xám
        sheet.getRange(selection.row, 0, selection.rowCount, selection.colCount).foreColor(i18nEnum.ColorTextExplanation.Suggest);
    });
    explanationFormHelper.changeStatusLockWorkbook(false, wb, true);
    wb.resumeEvent();
    wb.resumePaint();
}

/**
 * thêm cột custom
 * @param {*} wb 
 */
const commandInsertColumnsCustom = (wb) => {
    var sheet = wb.getActiveSheet();
    // Get selected range
    let rangeSelects = sheet?.getSelections();
    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;
    wb.suspendPaint();
    wb.suspendEvent();
    rangeSelects.forEach(function (selection) {
        sheet.addColumns(selection.col, selection.colCount); // Thêm cột mới     
        let format = sheet.tag()?.format;
        // nếu trong tag có format thì set format cho cột mới thêm
        if (format) {
            sheet.getRange(-1, selection.col, selection.rowCount, selection.colCount).formatter(format);
        }
        else {
            // mặc định là kiểu số
            sheet.getRange(-1, selection.col, selection.rowCount, selection.colCount).formatter(i18nEnum.FormatCell.Number);
        }

    });
    wb.resumeEvent();
    wb.resumePaint();
}
/**
 *command xóa dòng custom
 * @param {Workbook} wb 
 * @returns 
 */
const commandDeleteRowCustom = (wb) => {
    var sheet = wb.getActiveSheet();
    // Get selected range
    let rangeSelects = sheet.getSelections();
    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;
    rangeSelects.forEach(function (selection) {
        sheet.deleteRows(selection.row, selection.rowCount); // Xóa dòng
    });
}
/**
 *command thêm bảng dữ liệu (dòng chi tiết)
 * @param {Workbook} wb 
 * @returns 
 */
const commandInsertRowsDetail = (wb) => {
    wb.suspendPaint();
    wb.suspendEvent();
    var sheet = wb.getActiveSheet();
    // Get selected range
    let rangeSelects = sheet.getSelections();
    var rowCheck = explanationFormHelper.countIsDetailSheet(wb, 'isSummary');

    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;
    rangeSelects.forEach(function (selection) {
        sheet.addRows(selection.row + 1, selection.rowCount); // Thêm một dòng mới là dòng group
        // khi thêm dòng chi tiết thì thêm luôn 1 dòng tổng
        sheet.addRows(selection.row, selection.rowCount);
        let idCum = rowCheck ? rowCheck + 1 : 1;

        var idSummary = commonFunction.generateUUID(); // id của dòng tổng
        var tagSummary = {
            isSummary: true,
            id: idSummary,
            idCum: idCum,
            groupType: 20,
            dataCustomWb: {},
            startRow: null,
            endRow: null,
            startCol: null,
            endCol: null,
        };

        var idDetail = commonFunction.generateUUID(); // id của dòng chi tiết
        var idGroup = commonFunction.generateUUID(); // id của dòng group gần dòng chi tiết
        var rowTagDetail = {
            isDetail: true,
            id: idDetail,
            parentId: idGroup,
            idCum: idCum,
            numberOrderType: 1,
            takeParentOrder: true,
            groupType: 5,
            dataCustomWb: {},
            startRow: null,
            endRow: null,
            startCol: null,
            endCol: null,
        };
        // nếu là dòng chi tiết thì đánh dấu là isDetail
        sheet.setTag(selection.row + 1, -1, rowTagDetail);
        // set tag cho dòng tổng
        sheet.setTag(selection.row, -1, tagSummary);

        let cellTag = {};
        cellTag.accompanyingInfo = {
            report_field_type: i18nEnum.ReportExcelFieldType.Order,
        };
        // tag cho cột STT
        sheet.getCell(selection.row + 1, 1).tag(cellTag);
        var colCount = sheet.getColumnCount();
        var style = new GC.Spread.Sheets.Style();
        var styleSummary = new GC.Spread.Sheets.Style();
        var border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
        var range = sheet.getRange(selection.row + 1, 0, 1, colCount);
        var rangeSummary = sheet.getRange(selection.row, 0, 1, colCount);

        style.backColor = '#C6E0B4';
        style.borderLeft = border;
        style.borderTop = border;
        style.borderRight = border;
        style.borderBottom = border;
        styleSummary.backColor = 'yellow';
        styleSummary.borderLeft = border;
        styleSummary.borderTop = border;
        styleSummary.borderRight = border;
        styleSummary.borderBottom = border;
        range.setStyle(style);
        sheet.setText(selection.row + 1, 1, '[STT]');
        rangeSummary.setStyle(styleSummary);
        sheet.setText(selection.row, 2, 'Tổng số');
    });
    wb.resumeEvent();
    wb.resumePaint();
}
/**
 *command thêm bảng dữ liệu (dòng chi tiết bên phải) thiết lập động cột
 * @param {Workbook} wb 
 * @returns 
 */
const commandInsertShiftCellsRight = (wb) => {
    wb.suspendPaint();
    wb.suspendEvent();
    let sheet = wb.getActiveSheet(),
        sel = sheet.getSelections()[0];
    sheet.moveTo(
        sel.row,
        sel.col,
        sel.row,
        sel.col + sel.colCount,
        sel.rowCount,
        sheet.getColumnCount() - (sel.col + sel.colCount),
        GC.Spread.Sheets.CopyToOptions.all,
    );
    let style = new GC.Spread.Sheets.Style();
    let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
    style.borderLeft = border;
    style.borderTop = border;
    style.borderRight = border;
    style.borderBottom = border;
    style.backColor = '#FFCCFF';
    let tagColumn = {
        isColumn: true,
        idCum: 1,
    };
    sheet.getRange(sel.row, sel.col, sel.rowCount, sel.colCount).setStyle(style);
    for (let col = sel.col; col < sel.col + sel.colCount; col++) {
        for (let row = sel.row; row < sel.row + sel.rowCount; row++) {
            sheet.setStyle(row, col, style);
            sheet.setTag(row, -1, tagColumn);
        }
    }
    wb.resumeEvent();
    wb.resumePaint();
}
/**
 * command thêm bảng dữ liệu (dòng chi tiết ở dưới) thiết lập động cột
 * @param {workbook} wb 
 */
const commandInsertShiftCellsDown = (wb) => {
    wb.suspendPaint();
    wb.suspendEvent();
    let sheet = wb.getActiveSheet(),
        sel = sheet.getSelections()[0],
        idCum = null,
        tagSheet = sheet.tag(),
        infoRanges = tagSheet?.infoRanges;
    if (infoRanges) {
        for (var key in infoRanges) {
            if (infoRanges.hasOwnProperty(key)) {
                const element = infoRanges[key];
                if (explanationFormViewHelper.isCellInRange(sel.row, sel.col, element.row, element.col, element.rowNumber, element.colNumber)) {
                    idCum = element.idCum;
                    break;
                }
            }
        }
    }
    if (idCum != null) {
        infoRanges[idCum.toString()].rowNumber++;
        sheet.tag(tagSheet);
        let range = sheet.getRange(infoRanges[idCum.toString()].row + infoRanges[idCum.toString()].rowNumber - 1, infoRanges[idCum.toString()].col, 1, infoRanges[idCum.toString()].colNumber);
        let style = new GC.Spread.Sheets.Style();
        let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
        style.borderLeft = border;
        style.borderTop = border;
        style.borderRight = border;
        style.borderBottom = border;
        style.backColor = '#FFCCCC';
        range.setStyle(style);
    }

    wb.resumeEvent();
    wb.resumePaint();
}

